import { useState } from 'react';
import apiService from '../../axios/apiService';
import { useLocation } from 'react-router-dom';
import { getSearchParamFromLocation } from '../../utils/mapper';
import { message } from 'antd';

export const useClinicLocationUpdate = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const updateClinicLocation = async (clinicLocationId, data) => {
    // Update clinic
    setLoading(true);
    try {
      const clinicId = getSearchParamFromLocation('id', location);
      if (!clinicId) {
        return message.error('Please provide clinic ID');
      }
      if (!clinicLocationId) {
        return message.error('Please provide clinic location ID');
      }
      const response = await apiService.updateClinicLocation(
        clinicId,
        clinicLocationId,
        data
      );
      return response;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    updateClinicLocation,
  };
};
